const regex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript

export default function validateEmail(email: string) {
  return regex.test(email.toLowerCase());
}
